import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { X, Sparkles } from 'lucide-react';
import { ROUTE_MAP_EN_TO_ES } from '@/i18n/routeMap';

const AnnouncementBanner = () => {
  const [isVisible, setIsVisible] = useState(true);
  const { pathname } = useLocation();
  const isEs = pathname === '/es' || pathname.startsWith('/es/');

  if (!isVisible) return null;

  const newsLabel  = isEs ? 'NUEVO' : 'NEW';
  const headline   = isEs
    ? 'Carillas First Fit: una sonrisa nueva en solo 2 horas'
    : 'First Fit Veneers: a brand-new smile in just 2 hours';
  const subline    = isEs ? 'Sin tallado · Sin dolor · Mismo día' : 'No drilling · No pain · Same-day';
  const ctaLabel   = isEs ? 'Ver Cómo' : 'See How';
  const ariaClose  = isEs ? 'Cerrar anuncio' : 'Close announcement';
  const linkTarget = isEs ? ROUTE_MAP_EN_TO_ES['/first-fit-veneers'] : '/first-fit-veneers';

  return (
    <div className="bg-[#0d3b3b] text-white relative overflow-hidden" data-testid="announcement-banner">
      {/* animated gold shimmer accent on the left edge */}
      <div className="absolute inset-y-0 left-0 w-1 bg-gradient-to-b from-amber-300 via-amber-400 to-amber-500" />
      <div className="container mx-auto px-4 py-2.5 flex items-center justify-center gap-x-3 gap-y-1 flex-wrap text-center">
        <span className="inline-flex items-center gap-1.5 bg-amber-400 text-[#0d3b3b] text-[11px] font-extrabold uppercase tracking-wider px-2.5 py-0.5 rounded-full flex-shrink-0">
          <Sparkles className="w-3 h-3" />
          {newsLabel}
        </span>
        <span className="font-semibold text-sm sm:text-base">
          {headline}
        </span>
        <span className="hidden md:inline text-amber-200/90 text-xs font-medium">
          {subline}
        </span>
        <Link
          to={linkTarget}
          className="group ml-1 inline-flex items-center gap-1 bg-white text-[#0d3b3b] px-4 py-1 rounded-full text-sm font-bold hover:bg-amber-300 transition-colors flex-shrink-0"
          data-testid="announcement-cta"
        >
          {ctaLabel}
          <span className="transition-transform group-hover:translate-x-0.5">→</span>
        </Link>
        <button
          onClick={() => setIsVisible(false)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-white/60 hover:text-white"
          aria-label={ariaClose}
          data-testid="announcement-close"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
